import { render } from "./IconChannels.vue?vue&type=template&id=b59c938e&scoped=true&ts=true"
import script from "./IconChannels.vue?vue&type=script&lang=ts"
export * from "./IconChannels.vue?vue&type=script&lang=ts"

import "./IconChannels.vue?vue&type=style&index=0&id=b59c938e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59c938e"]])

export default __exports__